let GET_URL = ''
switch (process.env.VUE_APP_TITLE) {
  // 开发的测试环境
  case 'cu':
    GET_URL = 'http://qa.mentee.api.valeon.com/'
    break
  // 测试人员的测试环境
  case 'qa':
    GET_URL = 'https://qa-mentee-api.valeon.com/'
    break
  // 生产环境
  case 'production':
    GET_URL = 'https://menteeapi.zailairen.com/'
    break
  case 'demo':
    GET_URL = 'http://demo.mentee.api.valeon.com/'
    break
  // 本地开发
  default:
    // 张洪伟
    // GET_URL = 'http://172.16.1.31:26100/'
    // GET_URL = 'http://172.16.1.52:26100/'
    //  严勇
    // GET_URL = 'http://172.16.1.28:26100/'
    // 庞皓月
    // GET_URL = 'http://172.16.1.37:26100/'
    // 李越
    // GET_URL = 'http://10.1.2.87:26100/'
    GET_URL = 'https://qa-mentee-api.valeon.com/'
}
export default GET_URL
